import QuizForm from "../../../components/admin/quizzes/QuizForm";
import { useGetQuizQuery } from "../../../features/quizzes/quizzesAPI";
import { useParams } from "react-router";
function EditQuiz() {
  const { id } = useParams();
  const { data: quiz, isLoading, isSuccess, isError } = useGetQuizQuery(id);

  let form = null;
  if (isLoading) form = "Loading...";
  else if (isError) form = "Something went wrong!";
  else if (isSuccess) form = <QuizForm initialData={quiz} />;

  return (
    <main
      className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B] mt-8 space-y-6"
      style={{ width: "75%" }}
    >
      <h1 className="mb-10 text-center lws-section-title">Edit Quiz</h1>

      <div className="max-w-3xl mx-auto">{form}</div>
    </main>
  );
}

export default EditQuiz;
